import { DateTime } from "luxon";
import { LOCAL_TIMEZONE } from "../localTimezone";
import React from "react";

type Props = {
  value: DateTime;
  timezone: string;
  showTimezone?: boolean;
};

export const TradeDateComponent: React.FC<Props> = ({ value, timezone, showTimezone }) => {
  const zonedValue = value.setZone(timezone ?? LOCAL_TIMEZONE);

  return (
    <>
      {zonedValue.toLocaleString(DateTime.DATETIME_MED)}
      {showTimezone === true ? zonedValue.toFormat(" ZZZZ") : null}
    </>
  );
};
